import SubscriptionsSelector from '../SubscriptionsSelector'

export default ({ t, products, setSubscription, subscription, addToCart, cart, language }) => (
  <div className="content">
    <div className="m-b-lg">
      <h4 className="is-size-4 m-b-md">{t('common:select-subscription')}</h4>
      <p><a href="https://s3.amazonaws.com/tsd.mazdausa.com/MazdaServiceInfo/Mazda_Software_Explained_Before_Purchase.pdf" target="_blank">{t('common:subscription-common')}</a></p>
      <p>{t('common:esi-sub-disc')}</p>
      <p>{t('common:esi-content-14')}</p>
      <p>{t('common:esi-content-1')}</p>
      <ul>
        <li>{t('common:esi-content-2')}</li>
        <li>{t('common:esi-content-3')}</li>
        <li>{t('common:esi-content-4')}</li>
        <li>{t('common:esi-content-5')}</li>
        <li>{t('common:esi-content-6')}</li>
        <li>{t('common:esi-content-7')}</li>
      </ul>
      <p>
        {t('common:esi-content-8')}&nbsp;
        <a href="https://get.adobe.com/reader/" target="_blank">{t('common:click-here')}</a>
      </p>
      <p>{t('common:esi-content-9')}</p>
      <SubscriptionsSelector
        products={products}
        subscription={subscription}
        setSubscription={setSubscription}
        addToCart={addToCart}
        cart={cart}
        language={language}
        t={t} />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./components/ElectronicService/index.js